import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Primary CTA — purple fill, white text, pill radius (UEG LABS brand).
 */
export default function AccentButton({
  children,
  className,
  type = 'button',
  disabled,
  onClick,
  as: Component = 'button',
  variant = 'primary',
  ...rest
}) {
  const variants = {
    primary:
      'bg-space hover:bg-space/90 text-white rounded-full disabled:opacity-50 transition-transform hover:-translate-y-px',
    secondary:
      'bg-shell-card hover:bg-paper text-ink border border-shell-border rounded-full disabled:opacity-50 transition-transform hover:-translate-y-px',
    space:
      'bg-space hover:bg-space/90 text-white rounded-full disabled:opacity-50 transition-transform hover:-translate-y-px',
  };

  return (
    <Component
      type={Component === 'button' ? type : undefined}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'inline-flex items-center justify-center gap-2 text-sm font-medium px-4 py-2',
        variants[variant] || variants.primary,
        className,
      )}
      {...rest}>
      {children}
    </Component>
  );
}
